import { render, staticRenderFns } from "./WithdrawingDAOTokens.vue?vue&type=template&id=00a5cbd7&scoped=true&"
import script from "./WithdrawingDAOTokens.vue?vue&type=script&lang=js&"
export * from "./WithdrawingDAOTokens.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawingDAOTokens.vue?vue&type=style&index=0&id=00a5cbd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a5cbd7",
  null
  
)

export default component.exports